<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block" style="display:flex">
        <div class="block" style="margin-left:0px;display:flex">
          <span class="countryName">组织名字</span>
          <el-input placeholder="模糊查询" v-model="terrorist_name" clearable></el-input>
        </div>

        <div style="margin-left:20px">
          <el-row>
            <el-button type="success" @click="queryData()">查询</el-button>
          </el-row>
        </div>
      </div>
      <el-button type="success" style="margin:10px 0" @click="addCountryData()">新增条目</el-button>
      <el-table
        :data="tableData"
        style="width: 100%"
        :default-sort="{prop: 'date', order: 'descending'}"
      >
        <el-table-column prop="terrorist_name" label="恐怖组织名称"></el-table-column>
        <el-table-column prop="last_admin_username" label="旗帜">
          <template slot-scope="scope">
            <img v-if="scope.row.flag" :src="scope.row.flag" :alt="scope.row.flag">
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="add_time" label="创建时间" :formatter="addTime" sortable></el-table-column>
        <el-table-column prop="update_time" label="最后修改时间" :formatter="updateTime" sortable></el-table-column>
        
        <el-table-column prop="last_admin_username" label="操作人">
          <template slot-scope="scope">
            <span>{{scope.row.last_admin_username || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-row>
              <el-button type="text" size="small" @click="editCountryData(scope.row)">
                <i class="el-icon-edit"></i>编辑
              </el-button>
              <el-button type="text" size="small" @click="terrorisDeleteFn(scope.row)">
                <i class="el-icon-delete"></i>删除
              </el-button>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalList"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import api from "../api";
import { timestampToTime } from "@/mixins/tools.js";

export default {
  mixins: [timestampToTime],
  name: "services",
  data() {
    return {
      terrorist_name: "",
      tableData: [],
      currentPage: 1,
      totalList: null
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 获取数据
    getData(data) {
      api.terroristList(data).then(res => {
        // this.$message("请求成功!");
        this.tableData = res.list;
        this.totalList = res.recordcount;
        this.pageSize = res.pagecount;
      });
      // .catch(err => {
      //   console.log(err);
      // });
    },

    // 查询参数
    queryData() {
      let data = {
        terrorist_name: this.terrorist_name
      };
      if (data.terrorist_name) {
        this.getData(data);
      } else {
        this.getData();
      }
    },

   

    // 新增数据
    addCountryData() {
      localStorage.removeItem('temp_id')
      this.$router.push({
        name: "addOrganizations"
      });
    },

    // 修改数据
    editCountryData(row) {
      localStorage.removeItem('temp_id')
      let routeData = this.$router.resolve({
        name: "addOrganizations",
        query: {
          countryId: row.id,
          countryName: row.area_name,
          countryCapital: row.capital_name
        }
      });
      window.open(routeData.href, '_blank');
      
    },

    terrorisDeleteFn(row) {
      let datas = {
        id: row.id
      }
      this.$confirm('确定要删除吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
         api.terrorisDelete(datas)
          .then(res => {
            if(res.error_code == 0) {
              this.$message.success("删除成功！")
            }
            this.getData()
          })
          .catch(err => {
            
          });
      }).catch(() => {
      });
    },

  }
};
</script>

<style lang="scss" scoped>
.pagination {
  text-align: right;
  padding: 0 20px;
}
.countryName {
  margin-right: 10px;
  width: 100px;
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>